import { createApi } from '@reduxjs/toolkit/query/react';
import { baseUploadS3Query } from './config';

export const uploadS3Api = createApi({
  reducerPath: 'uploadS3Api',
  baseQuery: baseUploadS3Query,
  endpoints: (builder) => ({
    uploadFileByURL: builder.mutation<void, { url: string; body: FormData }>({
      query: ({ url, body }) => ({
        url,
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const { useUploadFileByURLMutation } = uploadS3Api;
